/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch } from '../fn/project-item-samples/api-project-item-samples-consultant-approve-or-reject-project-item-sample-patch';
import { ApiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Params } from '../fn/project-item-samples/api-project-item-samples-consultant-approve-or-reject-project-item-sample-patch';
import { apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Plain } from '../fn/project-item-samples/api-project-item-samples-consultant-approve-or-reject-project-item-sample-patch-plain';
import { ApiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Plain$Params } from '../fn/project-item-samples/api-project-item-samples-consultant-approve-or-reject-project-item-sample-patch-plain';
import { apiProjectItemSamplesCreateProjectItemSamplePost } from '../fn/project-item-samples/api-project-item-samples-create-project-item-sample-post';
import { ApiProjectItemSamplesCreateProjectItemSamplePost$Params } from '../fn/project-item-samples/api-project-item-samples-create-project-item-sample-post';
import { apiProjectItemSamplesCreateProjectItemSamplePost$Plain } from '../fn/project-item-samples/api-project-item-samples-create-project-item-sample-post-plain';
import { ApiProjectItemSamplesCreateProjectItemSamplePost$Plain$Params } from '../fn/project-item-samples/api-project-item-samples-create-project-item-sample-post-plain';
import { apiProjectItemSamplesDeleteProjectItemSampleDelete } from '../fn/project-item-samples/api-project-item-samples-delete-project-item-sample-delete';
import { ApiProjectItemSamplesDeleteProjectItemSampleDelete$Params } from '../fn/project-item-samples/api-project-item-samples-delete-project-item-sample-delete';
import { apiProjectItemSamplesDeleteProjectItemSampleDelete$Plain } from '../fn/project-item-samples/api-project-item-samples-delete-project-item-sample-delete-plain';
import { ApiProjectItemSamplesDeleteProjectItemSampleDelete$Plain$Params } from '../fn/project-item-samples/api-project-item-samples-delete-project-item-sample-delete-plain';
import { apiProjectItemSamplesGetAvailableProjectItemsPost } from '../fn/project-item-samples/api-project-item-samples-get-available-project-items-post';
import { ApiProjectItemSamplesGetAvailableProjectItemsPost$Params } from '../fn/project-item-samples/api-project-item-samples-get-available-project-items-post';
import { apiProjectItemSamplesGetAvailableProjectItemsPost$Plain } from '../fn/project-item-samples/api-project-item-samples-get-available-project-items-post-plain';
import { ApiProjectItemSamplesGetAvailableProjectItemsPost$Plain$Params } from '../fn/project-item-samples/api-project-item-samples-get-available-project-items-post-plain';
import { apiProjectItemSamplesGetProjectItemSamplePost } from '../fn/project-item-samples/api-project-item-samples-get-project-item-sample-post';
import { ApiProjectItemSamplesGetProjectItemSamplePost$Params } from '../fn/project-item-samples/api-project-item-samples-get-project-item-sample-post';
import { apiProjectItemSamplesGetProjectItemSamplePost$Plain } from '../fn/project-item-samples/api-project-item-samples-get-project-item-sample-post-plain';
import { ApiProjectItemSamplesGetProjectItemSamplePost$Plain$Params } from '../fn/project-item-samples/api-project-item-samples-get-project-item-sample-post-plain';
import { apiProjectItemSamplesGetProjectItemSamplesPost } from '../fn/project-item-samples/api-project-item-samples-get-project-item-samples-post';
import { ApiProjectItemSamplesGetProjectItemSamplesPost$Params } from '../fn/project-item-samples/api-project-item-samples-get-project-item-samples-post';
import { apiProjectItemSamplesGetProjectItemSamplesPost$Plain } from '../fn/project-item-samples/api-project-item-samples-get-project-item-samples-post-plain';
import { ApiProjectItemSamplesGetProjectItemSamplesPost$Plain$Params } from '../fn/project-item-samples/api-project-item-samples-get-project-item-samples-post-plain';
import { apiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch } from '../fn/project-item-samples/api-project-item-samples-owner-approve-or-reject-project-item-sample-patch';
import { ApiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch$Params } from '../fn/project-item-samples/api-project-item-samples-owner-approve-or-reject-project-item-sample-patch';
import { apiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch$Plain } from '../fn/project-item-samples/api-project-item-samples-owner-approve-or-reject-project-item-sample-patch-plain';
import { ApiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch$Plain$Params } from '../fn/project-item-samples/api-project-item-samples-owner-approve-or-reject-project-item-sample-patch-plain';
import { apiProjectItemSamplesUpdateProjectItemSamplePatch } from '../fn/project-item-samples/api-project-item-samples-update-project-item-sample-patch';
import { ApiProjectItemSamplesUpdateProjectItemSamplePatch$Params } from '../fn/project-item-samples/api-project-item-samples-update-project-item-sample-patch';
import { apiProjectItemSamplesUpdateProjectItemSamplePatch$Plain } from '../fn/project-item-samples/api-project-item-samples-update-project-item-sample-patch-plain';
import { ApiProjectItemSamplesUpdateProjectItemSamplePatch$Plain$Params } from '../fn/project-item-samples/api-project-item-samples-update-project-item-sample-patch-plain';
import { ApproveProjectItemSampleCommandResult } from '../models/approve-project-item-sample-command-result';
import { CreateProjectItemSampleCommandResult } from '../models/create-project-item-sample-command-result';
import { DeleteProjectItemSampleCommandResult } from '../models/delete-project-item-sample-command-result';
import { GetAvailableProjectItemsQueryResult } from '../models/get-available-project-items-query-result';
import { GetProjectItemSampleQueryResult } from '../models/get-project-item-sample-query-result';
import { GetProjectItemSamplesQueryResult } from '../models/get-project-item-samples-query-result';
import { OwnerApproveProjectItemSampleCommandResult } from '../models/owner-approve-project-item-sample-command-result';
import { UpdateProjectItemSampleCommandResult } from '../models/update-project-item-sample-command-result';

@Injectable({ providedIn: 'root' })
export class ProjectItemSamplesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProjectItemSamplesCreateProjectItemSamplePost()` */
  static readonly ApiProjectItemSamplesCreateProjectItemSamplePostPath = '/api/ProjectItemSamples/CreateProjectItemSample';

  /**
   * Creates a new project item Sample.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSamplesCreateProjectItemSamplePost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectItemSamplesCreateProjectItemSamplePost$Plain$Response(params?: ApiProjectItemSamplesCreateProjectItemSamplePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectItemSampleCommandResult>> {
    return apiProjectItemSamplesCreateProjectItemSamplePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new project item Sample.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSamplesCreateProjectItemSamplePost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectItemSamplesCreateProjectItemSamplePost$Plain(params?: ApiProjectItemSamplesCreateProjectItemSamplePost$Plain$Params, context?: HttpContext): Observable<CreateProjectItemSampleCommandResult> {
    return this.apiProjectItemSamplesCreateProjectItemSamplePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectItemSampleCommandResult>): CreateProjectItemSampleCommandResult => r.body)
    );
  }

  /**
   * Creates a new project item Sample.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSamplesCreateProjectItemSamplePost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectItemSamplesCreateProjectItemSamplePost$Response(params?: ApiProjectItemSamplesCreateProjectItemSamplePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectItemSampleCommandResult>> {
    return apiProjectItemSamplesCreateProjectItemSamplePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new project item Sample.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSamplesCreateProjectItemSamplePost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectItemSamplesCreateProjectItemSamplePost(params?: ApiProjectItemSamplesCreateProjectItemSamplePost$Params, context?: HttpContext): Observable<CreateProjectItemSampleCommandResult> {
    return this.apiProjectItemSamplesCreateProjectItemSamplePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectItemSampleCommandResult>): CreateProjectItemSampleCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemSamplesUpdateProjectItemSamplePatch()` */
  static readonly ApiProjectItemSamplesUpdateProjectItemSamplePatchPath = '/api/ProjectItemSamples/UpdateProjectItemSample';

  /**
   * Updates an existing project item Sample.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSamplesUpdateProjectItemSamplePatch$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectItemSamplesUpdateProjectItemSamplePatch$Plain$Response(params?: ApiProjectItemSamplesUpdateProjectItemSamplePatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectItemSampleCommandResult>> {
    return apiProjectItemSamplesUpdateProjectItemSamplePatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing project item Sample.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSamplesUpdateProjectItemSamplePatch$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectItemSamplesUpdateProjectItemSamplePatch$Plain(params?: ApiProjectItemSamplesUpdateProjectItemSamplePatch$Plain$Params, context?: HttpContext): Observable<UpdateProjectItemSampleCommandResult> {
    return this.apiProjectItemSamplesUpdateProjectItemSamplePatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectItemSampleCommandResult>): UpdateProjectItemSampleCommandResult => r.body)
    );
  }

  /**
   * Updates an existing project item Sample.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSamplesUpdateProjectItemSamplePatch()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectItemSamplesUpdateProjectItemSamplePatch$Response(params?: ApiProjectItemSamplesUpdateProjectItemSamplePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectItemSampleCommandResult>> {
    return apiProjectItemSamplesUpdateProjectItemSamplePatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing project item Sample.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSamplesUpdateProjectItemSamplePatch$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectItemSamplesUpdateProjectItemSamplePatch(params?: ApiProjectItemSamplesUpdateProjectItemSamplePatch$Params, context?: HttpContext): Observable<UpdateProjectItemSampleCommandResult> {
    return this.apiProjectItemSamplesUpdateProjectItemSamplePatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectItemSampleCommandResult>): UpdateProjectItemSampleCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemSamplesDeleteProjectItemSampleDelete()` */
  static readonly ApiProjectItemSamplesDeleteProjectItemSampleDeletePath = '/api/ProjectItemSamples/DeleteProjectItemSample';

  /**
   * Deletes a project item Sample.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSamplesDeleteProjectItemSampleDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesDeleteProjectItemSampleDelete$Plain$Response(params?: ApiProjectItemSamplesDeleteProjectItemSampleDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectItemSampleCommandResult>> {
    return apiProjectItemSamplesDeleteProjectItemSampleDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a project item Sample.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSamplesDeleteProjectItemSampleDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesDeleteProjectItemSampleDelete$Plain(params?: ApiProjectItemSamplesDeleteProjectItemSampleDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectItemSampleCommandResult> {
    return this.apiProjectItemSamplesDeleteProjectItemSampleDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectItemSampleCommandResult>): DeleteProjectItemSampleCommandResult => r.body)
    );
  }

  /**
   * Deletes a project item Sample.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSamplesDeleteProjectItemSampleDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesDeleteProjectItemSampleDelete$Response(params?: ApiProjectItemSamplesDeleteProjectItemSampleDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectItemSampleCommandResult>> {
    return apiProjectItemSamplesDeleteProjectItemSampleDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a project item Sample.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSamplesDeleteProjectItemSampleDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesDeleteProjectItemSampleDelete(params?: ApiProjectItemSamplesDeleteProjectItemSampleDelete$Params, context?: HttpContext): Observable<DeleteProjectItemSampleCommandResult> {
    return this.apiProjectItemSamplesDeleteProjectItemSampleDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectItemSampleCommandResult>): DeleteProjectItemSampleCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch()` */
  static readonly ApiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatchPath = '/api/ProjectItemSamples/ConsultantApproveOrRejectProjectItemSample';

  /**
   * Approves or rejects a project item Sample By Consultant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Plain$Response(params?: ApiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveProjectItemSampleCommandResult>> {
    return apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Approves or rejects a project item Sample By Consultant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Plain(params?: ApiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Plain$Params, context?: HttpContext): Observable<ApproveProjectItemSampleCommandResult> {
    return this.apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApproveProjectItemSampleCommandResult>): ApproveProjectItemSampleCommandResult => r.body)
    );
  }

  /**
   * Approves or rejects a project item Sample By Consultant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Response(params?: ApiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveProjectItemSampleCommandResult>> {
    return apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Approves or rejects a project item Sample By Consultant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch(params?: ApiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Params, context?: HttpContext): Observable<ApproveProjectItemSampleCommandResult> {
    return this.apiProjectItemSamplesConsultantApproveOrRejectProjectItemSamplePatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApproveProjectItemSampleCommandResult>): ApproveProjectItemSampleCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch()` */
  static readonly ApiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatchPath = '/api/ProjectItemSamples/OwnerApproveOrRejectProjectItemSample';

  /**
   * Approves or rejects a project item Sample By Owner.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch$Plain$Response(params?: ApiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OwnerApproveProjectItemSampleCommandResult>> {
    return apiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Approves or rejects a project item Sample By Owner.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch$Plain(params?: ApiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch$Plain$Params, context?: HttpContext): Observable<OwnerApproveProjectItemSampleCommandResult> {
    return this.apiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<OwnerApproveProjectItemSampleCommandResult>): OwnerApproveProjectItemSampleCommandResult => r.body)
    );
  }

  /**
   * Approves or rejects a project item Sample By Owner.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch$Response(params?: ApiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<OwnerApproveProjectItemSampleCommandResult>> {
    return apiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Approves or rejects a project item Sample By Owner.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch(params?: ApiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch$Params, context?: HttpContext): Observable<OwnerApproveProjectItemSampleCommandResult> {
    return this.apiProjectItemSamplesOwnerApproveOrRejectProjectItemSamplePatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<OwnerApproveProjectItemSampleCommandResult>): OwnerApproveProjectItemSampleCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemSamplesGetProjectItemSamplesPost()` */
  static readonly ApiProjectItemSamplesGetProjectItemSamplesPostPath = '/api/ProjectItemSamples/GetProjectItemSamples';

  /**
   * Retrieves a list of project item Sample.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSamplesGetProjectItemSamplesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesGetProjectItemSamplesPost$Plain$Response(params?: ApiProjectItemSamplesGetProjectItemSamplesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemSamplesQueryResult>> {
    return apiProjectItemSamplesGetProjectItemSamplesPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a list of project item Sample.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSamplesGetProjectItemSamplesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesGetProjectItemSamplesPost$Plain(params?: ApiProjectItemSamplesGetProjectItemSamplesPost$Plain$Params, context?: HttpContext): Observable<GetProjectItemSamplesQueryResult> {
    return this.apiProjectItemSamplesGetProjectItemSamplesPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectItemSamplesQueryResult>): GetProjectItemSamplesQueryResult => r.body)
    );
  }

  /**
   * Retrieves a list of project item Sample.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSamplesGetProjectItemSamplesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesGetProjectItemSamplesPost$Response(params?: ApiProjectItemSamplesGetProjectItemSamplesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemSamplesQueryResult>> {
    return apiProjectItemSamplesGetProjectItemSamplesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a list of project item Sample.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSamplesGetProjectItemSamplesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesGetProjectItemSamplesPost(params?: ApiProjectItemSamplesGetProjectItemSamplesPost$Params, context?: HttpContext): Observable<GetProjectItemSamplesQueryResult> {
    return this.apiProjectItemSamplesGetProjectItemSamplesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectItemSamplesQueryResult>): GetProjectItemSamplesQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemSamplesGetAvailableProjectItemsPost()` */
  static readonly ApiProjectItemSamplesGetAvailableProjectItemsPostPath = '/api/ProjectItemSamples/GetAvailableProjectItems';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSamplesGetAvailableProjectItemsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesGetAvailableProjectItemsPost$Plain$Response(params?: ApiProjectItemSamplesGetAvailableProjectItemsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAvailableProjectItemsQueryResult>> {
    return apiProjectItemSamplesGetAvailableProjectItemsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSamplesGetAvailableProjectItemsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesGetAvailableProjectItemsPost$Plain(params?: ApiProjectItemSamplesGetAvailableProjectItemsPost$Plain$Params, context?: HttpContext): Observable<GetAvailableProjectItemsQueryResult> {
    return this.apiProjectItemSamplesGetAvailableProjectItemsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAvailableProjectItemsQueryResult>): GetAvailableProjectItemsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSamplesGetAvailableProjectItemsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesGetAvailableProjectItemsPost$Response(params?: ApiProjectItemSamplesGetAvailableProjectItemsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAvailableProjectItemsQueryResult>> {
    return apiProjectItemSamplesGetAvailableProjectItemsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSamplesGetAvailableProjectItemsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesGetAvailableProjectItemsPost(params?: ApiProjectItemSamplesGetAvailableProjectItemsPost$Params, context?: HttpContext): Observable<GetAvailableProjectItemsQueryResult> {
    return this.apiProjectItemSamplesGetAvailableProjectItemsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAvailableProjectItemsQueryResult>): GetAvailableProjectItemsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectItemSamplesGetProjectItemSamplePost()` */
  static readonly ApiProjectItemSamplesGetProjectItemSamplePostPath = '/api/ProjectItemSamples/GetProjectItemSample';

  /**
   * Retrieves a project item Sample.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSamplesGetProjectItemSamplePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesGetProjectItemSamplePost$Plain$Response(params?: ApiProjectItemSamplesGetProjectItemSamplePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemSampleQueryResult>> {
    return apiProjectItemSamplesGetProjectItemSamplePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a project item Sample.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSamplesGetProjectItemSamplePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesGetProjectItemSamplePost$Plain(params?: ApiProjectItemSamplesGetProjectItemSamplePost$Plain$Params, context?: HttpContext): Observable<GetProjectItemSampleQueryResult> {
    return this.apiProjectItemSamplesGetProjectItemSamplePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectItemSampleQueryResult>): GetProjectItemSampleQueryResult => r.body)
    );
  }

  /**
   * Retrieves a project item Sample.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectItemSamplesGetProjectItemSamplePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesGetProjectItemSamplePost$Response(params?: ApiProjectItemSamplesGetProjectItemSamplePost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemSampleQueryResult>> {
    return apiProjectItemSamplesGetProjectItemSamplePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a project item Sample.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectItemSamplesGetProjectItemSamplePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectItemSamplesGetProjectItemSamplePost(params?: ApiProjectItemSamplesGetProjectItemSamplePost$Params, context?: HttpContext): Observable<GetProjectItemSampleQueryResult> {
    return this.apiProjectItemSamplesGetProjectItemSamplePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectItemSampleQueryResult>): GetProjectItemSampleQueryResult => r.body)
    );
  }

}
